import { Loading } from '@lokalise/louis';
import { useEffect } from 'react';

import { useGetActiveTasksQuery } from '@app/api/tasks';
import useDispatch from '@app/hooks/useDispatch';
import useEffectOnce from '@app/hooks/useEffectOnce';
import track, { AnalyticsEventName } from '@app/utils/analytics';

import { projectsActions } from '../../../ProjectsList/reducers';
import Tasks from './Tasks';
import { LoadingContainer } from './styles';

export type TasksPopoverProps = {
    projectId: string;
    focusTaskId?: string;
};

const TasksPopover = ({ projectId, focusTaskId }: TasksPopoverProps) => {
    const dispatch = useDispatch();
    const { data: tasks, isLoading } = useGetActiveTasksQuery({ projectId });

    useEffect(() => {
        if (tasks) {
            dispatch(projectsActions.setTaskBadge(tasks.length));
        }
    }, [dispatch, tasks]);

    useEffectOnce(() => {
        track(AnalyticsEventName.TASK_WIDGET_OPENED);
    });

    return isLoading || !tasks ? (
        <LoadingContainer>
            <Loading />
        </LoadingContainer>
    ) : (
        <Tasks tasks={tasks} focusTaskId={focusTaskId} />
    );
};

export default TasksPopover;
